/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router";
import { ReactComponent as LeftArrow } from "../../assets/icons/arrows/left-arrow.svg";
import { PrimaryButton } from "../../components";
import { useEffect } from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useBeevisionDrops } from "../../store/useBeevisionDrops";
import dayjs from "dayjs";

function BeevisionDropDetailsScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const params = useParams();
  const { getOneBeevisionDrop, oneBeevisionDrop } = useBeevisionDrops();

  /** Effects */
  useEffect(() => {
    if (!params?.id) return;
    getOneBeevisionDrop(params?.id);
  }, [params?.id]);

  /** Callbacks */
  const goBack = () => navigate(-1);

  const openUserDetails = () => {
    // @ts-ignore
    navigate(`/edit-user/${oneBeevisionDrop?.user?._id}`);
  };

  return (
    <div>
      <div className="flex flex-row items-center mb-6 justify-between">
        <div className="flex flex-row items-center justify-start">
          <LeftArrow onClick={goBack} className="mr-3 cursor-pointer" />
          <h1 className="font-satoshi text-base sm:text-2xl font-bold text-dark">
            #{params?.id}
          </h1>
        </div>
      </div>
      <div className="w-full flex flex-row mb-6">
        <div className="w-full sm:w-2/3 min-w-fit h-fit p-7 bg-white border border-gray-border drop-shadow-md mb-[20px] flex flex-row justify-between">
          <div className="flex flex-row items-center">
            <img
              alt="profileImage"
              className="w-[60px] h-[60px] sm:w-[100px] sm:h-[100px] rounded-full object-cover mr-8"
              src={
                // @ts-ignore
                oneBeevisionDrop?.user?.profileImage ??
                require("../../assets/pictures/dummy/dummy-avatar.png")
              }
            />
            <p className="self-center font-satoshi text-dark font-bold text-base sm:text-xl">
              {/* @ts-ignore */}
              {oneBeevisionDrop?.user?.first_name} {/* @ts-ignore */}
              {oneBeevisionDrop?.user?.last_name}
            </p>
          </div>
          <div className="self-center">
            <PrimaryButton onClick={openUserDetails} label="User details" />
          </div>
        </div>
      </div>
      <div className="w-full sm:w-2/3 min-w-fit bg-white border border-gray-border drop-shadow-md mb-[20px]">
        <div className="w-full bg-gray-50 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-medium text-base">
          <p className="flex flex-1">Details</p>
        </div>
        <div className="w-full bg-white hover:bg-gray-100 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base">
          <p className="flex flex-1">Location</p>
          <p className="flex flex-1 justify-end">
            {/* @ts-ignore */}
            {oneBeevisionDrop?.location?.name}
          </p>
        </div>
        <div className="w-full bg-white hover:bg-gray-100 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base">
          <p className="flex flex-1">Weight</p>
          <p className="flex flex-1 justify-end">
            {/* @ts-ignore */}
            {oneBeevisionDrop?.weight} {oneBeevisionDrop?.weightUnit}
          </p>
        </div>
        <div className="w-full bg-white hover:bg-gray-100 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base">
          <p className="flex flex-1">Date</p>
          <p className="flex flex-1 justify-end">
            {dayjs(oneBeevisionDrop?.createdAt).format("DD/MM/YYYY")}
          </p>
        </div>
        <div className="w-full bg-white hover:bg-gray-100 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base">
          <p className="flex flex-1">AI processed text</p>
          <p className="flex flex-1 justify-end">
            {oneBeevisionDrop?.AIProcessorResult}
          </p>
        </div>
        <div className="w-full bg-white hover:bg-gray-100 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base">
          <p className="flex flex-1">Total price</p>
          <p className="flex flex-1 justify-end">
            {new Intl.NumberFormat("nl-NL", {
              style: "currency",
              currency: "EUR",
            }).format(Number(oneBeevisionDrop?.totalPrice ?? 0) / 100)}
          </p>
        </div>
        {oneBeevisionDrop?.OCRText?.length ? (
          <div className="w-full bg-white hover:bg-gray-100 px-10 py-4 flex flex-row items-center justify-between font-satoshi text-dark font-normal text-base">
            <p className="flex flex-1">OCR Text</p>
            <p className="flex flex-1 justify-end">
              {oneBeevisionDrop?.OCRText?.join(",")}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default withProtectedRoute(BeevisionDropDetailsScreen);
